import { MenuItem, MenuList } from '@mui/material'
import React from 'react'
import { ValueSelection } from '../../services/DialogService'

type ValuePickerProps = {
	configuration: ValueSelection
	onClose: (v?: unknown) => void
}

export const ValuePicker: React.FC<ValuePickerProps> = ({
	configuration,
	onClose,
}: ValuePickerProps) => {
	return (
		<MenuList>
			{configuration.values.map((value, i) => (
				<MenuItem key={i} onClick={() => onClose(value)}>
					{value}
				</MenuItem>
			))}
		</MenuList>
	)
}
